module.exports = __webpack_public_path__ + "static/media/LQDR.549b999d.svg";